import styled from 'styled-components'

import { style } from 'theme'

export const Link = styled.a`
  text-decoration: underline;
  cursor: pointer;
`

export const Separator = styled.div`
  height: 1px;
  background-color: ${style(theme => theme.colors.ivory)};
  margin: 65px 0 20px 0;
`

export const StyledLabel = styled.div`
  font-size: 12px;
  color: ${style(theme => theme.colors.slate)};
  margin-top: 2px;
`
